module.exports = __webpack_public_path__ + "LB.png?18e49e96871bc1a10de416173e82b334";